import { Dispatch, Store } from "redux";
import { TActionRequest } from "../../base/types/redux";
import MiddlewareRegistry from "../../base/redux/MiddlewareRegistry";
import { apiGetSurveyOptions, apiCreateHealthCheck, apiGetHealthCheckInfo } from "./services";
import { ACTION_TYPES } from "./actionTypes";
import { setSurveyOptions, setCreateHealthCheckState, setHealthCheckInfo } from "./actions";
import { message } from 'antd';

export const middleware =
  ({ dispatch, getState }: Store) =>
  (next: Function) =>
  async (action: TActionRequest<any>) => {
    next(action);
    switch (action.type) {
      case ACTION_TYPES.GET_SURVEY_OPTIONS: {
        return await handleGetSurveyOptions(dispatch, action, getState);
      }
      case ACTION_TYPES.POST_CREATE_HEALTH_CHECK: {
        return await handleCreteHealthCheck(dispatch, action, getState);
      }
      case ACTION_TYPES.GET_HEALTH_CHECK_INFO: {
        return await handleGetHealthCheckInfo(dispatch, action, getState);
      }
    }
  };

MiddlewareRegistry.register(middleware);

const handleGetSurveyOptions = async (
  dispatch: Dispatch,
  action: TActionRequest<any>,
  getState: () => {  }
) => {
  try {
    const response = await apiGetSurveyOptions(action.params);
    if (response) {
      dispatch(setSurveyOptions(response));
    }
  } catch (err:any) {
    message.error(err.response?.data.status.message);
  }
};

const handleCreteHealthCheck = async (
  dispatch: Dispatch,
  action: TActionRequest<any>,
  getState: () => {  }
) => {
  try {
    action.params.health_insurance_time_unit = action.params.health_insurance.health_insurance_select ? action.params.health_insurance.health_insurance_select : 1;
    action.params.life_insurance_time_unit = action.params.life_insurance.life_insurance_select ? action.params.life_insurance.life_insurance_select : 1;
    action.params.health_insurance = action.params.health_insurance.health_insurance_input;
    action.params.life_insurance = action.params.life_insurance.life_insurance_input;
    const response = await apiCreateHealthCheck(action.params);
    if (response?.status.code === "A200") {
      dispatch(setCreateHealthCheckState({ isFetching: false, isSuccess: true, data: response.data }));
    } else {
      dispatch(setCreateHealthCheckState({ isFetching: false, isSuccess: false, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setCreateHealthCheckState({ isFetching: false, isSuccess: false, data: err }));
  }
}

const handleGetHealthCheckInfo = async (
  dispatch: Dispatch,
  action: TActionRequest<null>,
  getState: () => {  }
) => {
  try {
    const response = await apiGetHealthCheckInfo();
    if (response) {
      dispatch(setHealthCheckInfo(response));
    }
  } catch (err:any) {
    message.error(err.response?.data.status.message);
  }
};